import { Address } from "@app/provider/profile";

export type AddressCompareFields = Pick<
  Address,
  "city" | "countryCode" | "zipCode" | "state" | "street1"
>;

export const addressesMatch = (
  initialValue: AddressCompareFields | null,
  newValue: AddressCompareFields | null
): boolean => {
  if (!initialValue || !newValue) return false;

  const isCityEqual = initialValue.city === newValue.city;
  const isCountryCodeEqual = initialValue.countryCode === newValue.countryCode;
  const isZipCodeEqual = initialValue.zipCode === newValue.zipCode;
  const isStateEqual =
    initialValue.countryCode === "US"
      ? initialValue.state === newValue.state
      : true;
  const compareStreet1 =
    (initialValue.street1 ?? "").trim() === (newValue.street1 ?? "").trim();

  const res =
    isCityEqual &&
    isCountryCodeEqual &&
    isZipCodeEqual &&
    isStateEqual &&
    compareStreet1;

  return res;
};
